<template>
  <div class="base-switcher" :class="className">
    <label v-if="label">{{ label }}</label>
    <div class="base-switcher__wrapper">
      <BaseButton
        class="base-switcher__btn"
        :class="{ 'base-switcher__btn--selected': bool}"
        :title="trueLabel"
        @click.native="bool = true"
      ></BaseButton>
      <BaseButton
        class="base-switcher__btn"
        :class="{ 'base-switcher__btn--selected': !bool}"
        :title="falseLabel"
        @click.native="bool = false"
      ></BaseButton>
    </div>
    <TypographyInputHint v-if="hint">{{ hint }}</TypographyInputHint>
  </div>
</template>

<script>
  export default {
    props: {
      value: [ Boolean, String ],
      trueLabel: { default: 'OPEN' },
      falseLabel: { default: 'CLOSED' },
      label: String,
      hint: String,
      fillSpace: Boolean
    },
    data () {
      return {
        bool: false
      }
    },
    computed: {
      className () {
        return {
          'base-switcher--fill-space': this.fillSpace
        }
      }
    },
    watch: {
      value: {
        handler (val) {
          this.bool = !!val
        },
        immediate: true
      },
      bool (val) {
        this.$emit('input', val)
      }
    }
  }
</script>

<style lang="scss">
  @import './src/assets/styles/colors.scss';
  @import './src/assets/styles/mixins.scss';

  .base-switcher {

    &__wrapper {
      display: flex;
    }

    .base-switcher__btn {
      position: relative;
      color: $color-purple;
      font-size: 11px;
      font-weight: 600;
      border-color: $color-link-water;

      &:first-of-type {
        border-radius: 3px 0 0 3px;
      }

      &:last-of-type {
        border-radius: 0 3px 3px 0;
      }

      &:focus {
        z-index: 10;
        background: #F4F5FA;
        border-color: $color-purple;
        box-shadow: inset 0 0 8px rgba(92,106,196,.3), inset 0 0 0 1px $color-purple;
      }

      &--selected {
        z-index: 10;
        background: #f4f5fa;
        box-shadow: inset 0 0 8px rgba(92,106,196,.3);
      }

      .base-button__title {
        margin: 0 12px;
      }
    }

    label {
      display: block;
      width: 100%;
      margin-bottom: 4px;
      font-size: 14.6px;
      line-height: 1.43;
    }

    .TypographyInputHint {
      width: 100%;
    }

    &--fill-space {
      .base-switcher__btn {
        width: 50%;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/base/BaseSwitcher.vue